import { render, staticRenderFns } from "./Mypage.html?vue&type=template&id=2c02f1f0&scoped=true&"
import script from "./Mypage.ts?vue&type=script&lang=ts&"
export * from "./Mypage.ts?vue&type=script&lang=ts&"
import style0 from "./Mypage.css?vue&type=style&index=0&id=2c02f1f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02f1f0",
  null
  
)

export default component.exports